import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import TaskActions from "../../../../../../assets/icons/Icon-Flow-Blue-16px.svg";
import BaseActionsRow from "./BaseActionsRow";
import SystemActionsRow from "./SystemActionsRow";
import CustomActionsRow from "./CustomActionsRow";
import HiddenBaseActionsRow from "./HiddenBaseActionsRow";
import SectionSubheader from "../subcomponents/SectionSubheader";

const TaskActionsSection = ({
  workflowBaseActions,
  workflowSystemActions,
  workflowActions,
  setSelectedWorkflowAction,
  setIsModelOpen,
  hideBaseAction,
  hideSystemAction,
  setFieldName,
  handleActionSwap,
  removeField,
  removeInitialAction,
  addNewWorkflowAction,
}) => {
  const workflowCustomActionsList = (workflowActions || []).filter((x) => !x.IsHidden && !x.IsBase && !x.IsSystem);
  const workflowCustomActionsListCount = workflowCustomActionsList.length;

  const workflowBaseActionsList = (workflowBaseActions || []).filter((x) => !x.IsHidden && x.IsBase);
  const workflowBaseActionsListCount = workflowBaseActionsList.length;

  const workflowSystemActionsList = (workflowSystemActions || []).filter((x) => !x.IsHidden && x.IsSystem);
  const workflowSystemActionsListCount = workflowSystemActionsList.length;

  return (
    <div className="workflow-section-panel">
      <div className="workflow-section-description">
        <img src={TaskActions} alt="Task Actions" />{" "}
        Task Actions
      </div>

      <div className="workflow-status-section-body">
        {/* Custom Actions header */}
        <SectionSubheader title="Custom Actions" count={workflowCustomActionsListCount} />
        { workflowCustomActionsList.map((field, fieldIdx) => (
          <CustomActionsRow
            key={field?.Id}
            field={field}
            index={fieldIdx}
            baseVisibleCount={(workflowBaseActions || []).filter((x) => !x.IsHidden)?.length || 0}
            isFirst={fieldIdx === 0}
            isLast={fieldIdx === (workflowCustomActionsList || []).length - 1}
            onNameChange={(id, name) => setFieldName(id, name)}
            onOpen={(f) => {
              setSelectedWorkflowAction({ ...f });
              // setIsModelOpen(true);
            }}
            onMoveUp={() => handleActionSwap(fieldIdx - 1, fieldIdx)}
            onMoveDown={() => handleActionSwap(fieldIdx, fieldIdx + 1)}
            onDelete={() => {
              removeField(fieldIdx);
              removeInitialAction(field.Name);
            }}
          />
        ))}

        <div className="add-btn-workflow-container mb-3">
          <Button className="add-field-btn-workflow" variant="outline-primary" onClick={addNewWorkflowAction}>
            <span className="add-field-btn-text">Add New Task Action</span>
            <div className="add-field-icon" />
          </Button>
        </div>

        {/* Base Actions header */}
        <SectionSubheader title="TRIYO Base Actions" count={workflowBaseActionsListCount} />
        { workflowBaseActionsList.map((field, fieldIdx) => (
          <BaseActionsRow
            key={field?.Id}
            field={field}
            index={fieldIdx}
            onHide={(id, hidden) => hideBaseAction(id, hidden)}
            onOpen={(f) => {
              setSelectedWorkflowAction({ ...f });
              // keep parity with current behavior (modal may open internally)
              // if your modal expects explicit open, uncomment next line:
              // setIsModelOpen(true);
            }}
          />
          ))
        }

        {(workflowBaseActions || [])
          .filter((x) => x.IsHidden)
          .map((field, fieldIdx) => (
            <HiddenBaseActionsRow key={field?.Id} field={field} index={fieldIdx} onUnhide={(id, hidden) => hideBaseAction(id, hidden)} />
          ))
        }

        {/* System Actions header */}
        <SectionSubheader title="TRIYO System Actions" count={workflowSystemActionsListCount} />
        { workflowSystemActionsList.map((field, fieldIdx) => (
          <SystemActionsRow
            key={field?.Id}
            field={field}
            index={fieldIdx}
            onHide={(id, hidden) => hideSystemAction(id, hidden)}
            onOpen={(f) => {
              setSelectedWorkflowAction({ ...f });
              // keep parity with current behavior (modal may open internally)
              // if your modal expects explicit open, uncomment next line:
              // setIsModelOpen(true);
            }}
          />
          ))
        }

        {(workflowSystemActions || [])
          .filter((x) => x.IsHidden)
          .map((field, fieldIdx) => (
            <HiddenBaseActionsRow key={field?.Id} field={field} index={fieldIdx} onUnhide={(id, hidden) => hideSystemAction(id, hidden)} />
          ))
        }
      </div>
    </div>
  );
};

TaskActionsSection.propTypes = {
  workflowBaseActions: PropTypes.array.isRequired,
  workflowSystemActions: PropTypes.array.isRequired,
  workflowActions: PropTypes.array.isRequired,
  setSelectedWorkflowAction: PropTypes.func.isRequired,
  setIsModelOpen: PropTypes.func.isRequired,
  hideBaseAction: PropTypes.func.isRequired,
  hideSystemAction: PropTypes.func.isRequired,
  setFieldName: PropTypes.func.isRequired,
  handleActionSwap: PropTypes.func.isRequired,
  removeField: PropTypes.func.isRequired,
  removeInitialAction: PropTypes.func.isRequired,
  addNewWorkflowAction: PropTypes.func.isRequired,
};

export default TaskActionsSection;
